import React from 'react';

import './App.scss';
import CtaSection from './components/cta/CtaSection';
import Header from './components/header/Header';
import Hero from './components/hero/Hero';
import PillarsSection from './components/pillars/PillarsSection';
import ProcessSection from './components/process/ProcessSection';
import SiteFooter from './components/site-footer/SiteFooter';
import Divider from './components/ui/Divider';
import WhySection from './components/why/WhySection';

export default function App() {
  return (
    <div className="app">
      <a className="skip-link" href="#main">
        Skip to content
      </a>

      <Header />

      <main id="main">
        <Hero />
        <Divider />
        <PillarsSection />
        <Divider />
        <ProcessSection />
        <WhySection />
        <CtaSection />
      </main>

      <SiteFooter />
    </div>
  );
}
